import React, { useState } from 'react';
import DocumentUpload from '../../Bookings/Edit/Documents/Partials/DocumentUpload';
import DocumentList from '../../Bookings/Edit/Documents/Partials/DocumentList';
import Chatbox from '../../Bookings/Edit/Chat/Partials/Chatbox';
import PrivateModeSwitch from '../../Bookings/Edit/Partials/PrivateModeSwitch';
import { CardTitle } from '../../../ui';
import { PrivateModeKindEnum } from '@koob/enums';
import { useTranslation } from 'react-i18next';
import { useAsync } from 'react-async';
import {
  getBookingDocumentsBySecret,
  getBookingMessageBySecret,
} from 'api/node/hotelkeeper';

export default function HotelKeeperDocuments({ bookingId, secret }) {
  const [privateMode, setPrivateMode] = useState(true);

  const { data: documents, reload: reloadDocuments } = useAsync({
    promiseFn: getBookingDocumentsBySecret,
    secret,
  });

  const { data: messages, reload } = useAsync({
    promiseFn: getBookingMessageBySecret,
    secret,
  });

  const { t } = useTranslation('bookings');

  return bookingId ? (
    <div className="py-5">
      <CardTitle>{t('chat.title')}</CardTitle>

      <div className="mt-4">
        <PrivateModeSwitch
          privateMode={privateMode}
          setPrivateMode={setPrivateMode}
          kind={PrivateModeKindEnum.HOTEL_KEEPER}
        />
      </div>

      <div className="grid grid-cols-2 space-x-5">
        <Chatbox
          messages={messages?.data}
          reload={() => {
            reload();
            reloadDocuments();
          }}
          bookingId={bookingId}
          secret={secret}
          privateMode={privateMode}
          displayAs="hotel"
        />

        <div className="flex flex-col space-y-5">
          <DocumentUpload
            bookingId={bookingId}
            onUpload={reloadDocuments}
            privateMode={privateMode}
            secret={secret}
          />

          <DocumentList
            documents={documents?.data}
            bookingId={bookingId}
            secret={secret}
            isTrip={false}
          />
        </div>
      </div>
    </div>
  ) : null;
}
